function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusRejected = function SvgStatusRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "#fff",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7767.479-2944.1h-.021a10 10 0 0 1-10-10 10 10 0 0 1 10-10h.041a10.03 10.03 0 0 1 10 10 10.03 10.03 0 0 1-10 10zm-.021-2a8.009 8.009 0 0 0 8-8 7.959 7.959 0 0 0-1.47-4.618l-11.146 11.148a7.956 7.956 0 0 0 4.616 1.47zm-2.209-15.691a8.015 8.015 0 0 0-5.789 7.69 7.959 7.959 0 0 0 1.5 4.666l11.161-11.161a7.962 7.962 0 0 0-4.647-1.506 8.313 8.313 0 0 0-2.225.311z",
    "data-name": "Union 12",
    style: {
      fill: "#e03861"
    },
    transform: "translate(7778.5 2965.1)"
  }));
};
export default SvgStatusRejected;